<template>
  <vca-card>
    <h2>{{ $t("profile.settings.header") }}</h2>
    <Settings v-if="loaded" />
  </vca-card>
</template>

<script>
import Settings from "@/components/account/AccountSettings";
import { mapGetters } from "vuex";
export default {
  name: "AccountSettings",
  components: { Settings },
  created() {
    this.$store
      .dispatch({
        type: "organisations/getByID",
        data: this.user.crew.organisation_id,
      })
      .finally(() => (this.loaded = true));
  },
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "user/current",
    }),
  },
};
</script>
